var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.42857C0 0.639593 0.601099 0 1.34259 0H22.8241C23.5656 0 24.1667 0.639593 24.1667 1.42857C24.1667 2.21755 23.5656 2.85714 22.8241 2.85714H1.34259C0.6011 2.85714 0 2.21755 0 1.42857Z",
    fill: "#5E6062"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 9.21102 0.601099 8.57143 1.34259 8.57143H22.8241C23.5656 8.57143 24.1667 9.21102 24.1667 10C24.1667 10.789 23.5656 11.4286 22.8241 11.4286H1.34259C0.6011 11.4286 0 10.789 0 10Z",
    fill: "#5E6062"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.5714C0 17.7825 0.601099 17.1429 1.34259 17.1429H22.8241C23.5656 17.1429 24.1667 17.7825 24.1667 18.5714C24.1667 19.3604 23.5656 20 22.8241 20H1.34259C0.6011 20 0 19.3604 0 18.5714Z",
    fill: "#5E6062"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBurger);
export default __webpack_public_path__ + "static/media/menuBurger.6d34db9f707e6422762bc7ef43cebf2b.svg";
export { ForwardRef as ReactComponent };